<template>
  <v-card flat class="tabs-module" :class="paramTabs.class">
    <not-allowed v-if="!AllowedDisplay" :page="page" :module="idmodule" />

    <template v-else>
      <div class="tabs-module__layout" :class="{ 'tabs-module__layout--vertical': paramTabs.vertical && !isMobile }">
      <v-tabs
        v-model="tab"
        :right="paramTabs.right && !isMobile"
        :background-color="paramTabs.bgcolor"
        :centered="paramTabs.centered && !isMobile"
        :dark="paramTabs.dark"
        :icons-and-text="paramTabs.iconText"
        :vertical="paramTabs.vertical && !isMobile"
        show-arrows="mobile"
        center-active
        prev-icon="mdi-chevron-left"
        next-icon="mdi-chevron-right"
        :class="['tabs-module__headers', { 'tabs-module__headers--themed': !paramTabs.bgcolor }]"
      >
        <v-tabs-slider />

        <v-tab
          v-for="item in visibleTabs"
          :key="`tab-header-${item.tabulation.id || 'dynamic'}-${item.index}`"
          :ref="`guideTab-${item.index}`"
          :data-guide-target="`module:${idmodule}:tab:${item.tabulation.id}`"
          :href="`#tab-${item.index}`"
          :class="item.tabulation.paramstab.class"
          :dark="item.tabulation.paramstab.dark"
          @click="setActiveTab(item.index)"
        >
          <v-icon v-if="item.tabulation.paramstab.icon" :left="!paramTabs.iconText" small>
            {{ item.tabulation.paramstab.icon }}
          </v-icon>
          <span class="tabs-module__label">{{ item.tabulation.name }}</span>
          <rights-indicator :checks="item.tabulation.id ? [{ core: 'tabs', id: item.tabulation.id }] : []" :label="item.tabulation.name" />
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" touchless class="tabs-module__content">
        <v-tab-item
          v-for="item in visibleTabs"
          :key="`tab-content-${item.tabulation.id || 'dynamic'}-${item.index}`"
          :id="`tab-${item.index}`"
          :value="`tab-${item.index}`"
          :dark="item.tabulation.paramstab.dark"
        >
          <div v-if="isAdmin && item.tabulation.content" class="tabs-module__edit-tools">
            <v-switch
              v-model="isModified[item.tabulation.id]"
              label="Modifier la mise en page"
              dense
              inset
              hide-details
              class="tabs-module__edit-switch ma-0 pa-0"
            />
            <v-btn
              v-if="isModified[item.tabulation.id]"
              x-small
              depressed
              color="primary"
              @click="savePage(item.tabulation)"
            >
              <v-icon left small>mdi-content-save</v-icon>Enregistrer
            </v-btn>
          </div>

          <CPage
            v-if="item.tabulation.content && getReload[item.index] === 1"
            :pageTemplate="item.tabulation.content"
            :customparams="item.tabulation.params"
            :page="page"
            :modal="modal"
            :modalKey="modalKey"
            :form="form"
            :hook="hook"
            :mod="isModified[item.tabulation.id]"
            @sendDatas="sendDatas"
            @recepVal="template => recupTemplate(item.tabulation, template)"
          />

          <main-component
            v-if="!item.tabulation.content && item.tabulation.page && getReload[item.index] === 1"
            :key="getReload[item.index]"
            :customparams="item.tabulation.params"
            :page="item.tabulation.page"
            :modal="modal"
            :modalKey="modalKey"
            :independant="true"
            :typeform="defineTypeFormPage(item.tabulation)"
            :hook="hook"
          />
        </v-tab-item>
      </v-tabs-items>
      </div>
    </template>
  </v-card>
</template>

<script>
import { client } from '../mixins'

export default {
  name: 'TabsModule',
  inject: { chatResourceEmbedded: { default: false } },
  mixins: [client],
  data() {
    return {
      show: false,
      AllowedDisplay: true,
      tab: '',
      listTabs: [],
      paramTabs: {
        class: '',
        bgcolor: '',
        centered: false,
        right: false,
        dark: false,
        iconText: false,
        vertical: false
      },
      isModified: {},
      params: {},
      getReload: {}
    }
  },
  computed: {
    activeTab() {
      return this.$store.getters.activeTab[this.tabStoreKey]
    },
    pendingActiveTabs() {
      return this.$store.getters.pendingActiveTabs
    },
    navigationToken() {
      const page = this.$store.getters.specificPage(this.modalKey)
      return (page && page.params && page.params.__activeTabsNavigation) || this.params.__activeTabsNavigation
    },
    tabStoreKey() {
      return this.chatResourceEmbedded ? `${this.modalKey}:${this.idmodule}` : this.idmodule
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    isAdmin() {
      return !this.chatResourceEmbedded && Number(this.$store.getters.currentUser.type) === 3
    },
    visibleTabs() {
      return this.listTabs
        .map((tabulation, index) => ({ tabulation, index }))
        .filter(item => item.tabulation.show !== 'none')
    }
  },
  watch: {
    activeTab(value) {
      const index = this.normalizeTabIndex(value)
      this.tab = `tab-${index}`
      this.activateTabContent(index)
    },
    navigationToken() { this.applyPendingTabRequest() },
    pendingActiveTabs() { this.applyPendingTabRequest() },
  },
  mounted() {
    const currentPage = this.$store.getters.specificPage(this.modalKey)
    const pageParams = currentPage && this.isParamsObject(currentPage.params) ? currentPage.params : {}
    const customParams = this.isParamsObject(this.customparams) ? this.customparams : {}
    this.params = { ...pageParams, ...customParams }

    const cached = this.$store.getters.getModuleDatas({ page: this.modalKey, id: this.idmodule })
    if(cached) {
      this.manageDatas(cached.datas, this.navigationToken)
      this.$store.dispatch('removeModuleDatas', { page: this.modalKey, id: this.idmodule })
    } else {
      this.callAPI()
    }
  },
  methods: {
    guideModuleTargets() {
      return this.visibleTabs.map(({ tabulation, index }) => {
        const activate = () => this.setActiveTab(index)
        const repeated = this.visibleTabs.filter(item => item.tabulation.id === tabulation.id).length > 1
        const key = `module:${this.idmodule}:tab:${tabulation.id}${repeated ? `:occurrence:${index + 1}` : ''}`
        return this.guideTarget(key, () => {
          const references = this.$refs[`guideTab-${index}`]
          const reference = Array.isArray(references) ? references[0] : references
          return reference && (reference.$el || reference)
        }, { open: activate, click: activate }, tabulation.name)
      })
    },
    sendDatas(payload) {
      this.$emit('sendDatas', payload)
    },
    callAPI() {
      const params = { ...this.params }
      delete params.__activeTabsNavigation
      const responseToken = this.navigationToken
      return this.API({ type: 'post', url: 'displaymodule', params: { id: this.idmodule, params, querys: this.$route.query || {} } })
        .then(response => this.manageDatas(response.data, responseToken))
    },
    manageDatas(datas, responseToken = this.params.__activeTabsNavigation) {
      if(this._isBeingDestroyed || this._isDestroyed) return
      if(!datas.success) {
        this.AllowedDisplay = false
        this.$emit('isloaded', { mod: this.idmodule, resp: true })
        return
      }

      this.listTabs = Array.isArray(datas.tabs)
        ? datas.tabs.map(tabulation => ({
          ...tabulation,
          params: {
            ...this.params,
            ...(this.isParamsObject(tabulation.params) ? tabulation.params : {})
          }
        }))
        : []
      this.paramTabs = { ...this.paramTabs, ...(datas.params || {}) }
      this.getReload = this.listTabs.reduce((reload, tabulation, index) => {
        reload[index] = 0
        return reload
      }, {})

      const pendingIndex = this.consumeRequestedTabIndex(responseToken)
      const index = pendingIndex === null ? this.normalizeTabIndex(this.activeTab) : pendingIndex
      this.tab = `tab-${index}`
      this.setActiveTab(index)
      this.show = true
    },
    isParamsObject(value) {
      return value !== null && typeof value === 'object' && !Array.isArray(value)
    },
    applyPendingTabRequest() {
      const token = this.navigationToken
      if (!this.show || !token || this.pendingActiveTabs?.token !== token) return
      // Le contexte mis à jour est transmis aux onglets enfants déjà présents.
      if (this.params.__activeTabsNavigation !== token) {
        this.params = { ...this.params, __activeTabsNavigation: token }
        this.listTabs = this.listTabs.map(tabulation => ({
          ...tabulation, params: { ...tabulation.params, __activeTabsNavigation: token },
        }))
      }
      const index = this.consumeRequestedTabIndex(token)
      if (index === null) return
      this.tab = `tab-${index}`
      this.setActiveTab(index)
    },
    consumeRequestedTabIndex(token) {
      const batch = this.pendingActiveTabs
      if (!token || !batch || batch.token !== token) return null
      const requests = batch.requests.filter(request => Number(request.moduleid) === Number(this.idmodule))
      if (!requests.length) return null
      let target
      for (const request of requests) {
        target = this.visibleTabs.find(({ tabulation }) => Number(tabulation.id) === Number(request.tabid)
          && Object.entries(request.params || {}).every(([key, expected]) => {
            if (!Object.prototype.hasOwnProperty.call(tabulation.params, key)) return false
            const actual = tabulation.params[key]
            if (actual === expected) return true
            if (actual === null || actual === undefined || expected === null || expected === undefined) return false
            return typeof actual !== 'object' && typeof expected !== 'object' && String(actual) === String(expected)
          }))
        if (target) break
      }
      // Une demande est ponctuelle, même si sa cible n'est plus visible ou n'existe plus.
      this.$store.dispatch('consumePendingActiveTabsForModule', { token, moduleid: this.idmodule })
      return target ? target.index : this.normalizeTabIndex(undefined)
    },
    normalizeTabIndex(value) {
      const requested = Number(value)
      const visibleIndexes = this.visibleTabs.map(item => item.index)
      if(Number.isInteger(requested) && visibleIndexes.includes(requested)) return requested
      return visibleIndexes.length ? visibleIndexes[0] : 0
    },
    activateTabContent(index) {
      const reload = {}
      this.listTabs.forEach((tabulation, tabIndex) => { reload[tabIndex] = tabIndex === index ? 1 : 0 })
      this.getReload = reload
    },
    setActiveTab(value) {
      const index = this.normalizeTabIndex(value)
      this.$store.dispatch('setActivTab', { hook: this.tabStoreKey, tab: index })
      this.activateTabContent(index)
    },
    savePage(tabulation) {
      const current = this.listTabs.find(item => item.id === tabulation.id)
      if(!current) return
      this.API({ type: 'put', url: 'tabulation/savecontent', params: { id: current.id, content: current.content } })
        .then(() => this.$toast.success('Mise en page enregistrée'))
    },
    recupTemplate(tabulation, template) {
      const current = this.listTabs.find(item => item.id === tabulation.id)
      if(current) current.content = template
    },
    defineTypeFormPage(tabulation) {
      const route = this.newurl({ page: tabulation.page, replace: {}, returnElement: 'all' })
      return route && route.props ? route.props.typeform : undefined
    }
  }
}
</script>

<style scoped>
.tabs-module {
  overflow: hidden;
  border: 1px solid #e5e7ef;
  border-radius: 10px !important;
  background: var(--app-card, #fff);
}
.tabs-module__headers {
  border-bottom: 1px solid #e8eaf0;
}
.tabs-module__headers--themed ::v-deep .v-tabs-bar { background: var(--app-tabs, #fff) !important; }
.tabs-module__layout--vertical { display: flex; align-items: stretch; }
.tabs-module__layout--vertical .tabs-module__headers { flex: 0 0 auto; border-right: 1px solid #e8eaf0; border-bottom: 0; }
.tabs-module__layout--vertical .tabs-module__content { flex: 1 1 auto; min-width: 0; }
.tabs-module__headers ::v-deep .v-tab {
  min-width: auto;
  min-height: 46px;
  padding: 0 18px;
  font-size: .92rem;
  font-weight: 600;
  letter-spacing: .01em;
  text-transform: none;
  color: var(--app-tabs-text, #4a4a4a) !important;
}
.tabs-module__headers ::v-deep .v-tab--active {
  background: var(--app-tabs-active-background, #f0f1fa);
  color: var(--app-tabs-active, #3f51b5) !important;
}
.tabs-module__headers ::v-deep .v-tabs-slider {
  background-color: var(--app-tabs-active, #3f51b5) !important;
  border-color: var(--app-tabs-active, #3f51b5) !important;
}
.tabs-module__content {
  background: var(--app-tabs-content, transparent);
}
.tabs-module__edit-tools {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  min-height: 28px;
  padding: 2px 8px;
  border-bottom: 1px solid #eceef4;
  background: var(--app-toolbar, #fafbfe);
}
.tabs-module__edit-switch ::v-deep .v-input__slot { min-height: 24px; }
.tabs-module__edit-switch ::v-deep .v-label { font-size: .75rem; }
.tabs-module__edit-switch ::v-deep .v-input--selection-controls__input {
  width: 32px;
  height: 20px;
  margin-right: 4px;
  transform: scale(.78);
  transform-origin: center;
}
@media (max-width: 960px) {
  .tabs-module { border-radius: 7px !important; }
  .tabs-module__headers ::v-deep .v-slide-group__prev,
  .tabs-module__headers ::v-deep .v-slide-group__next {
    display: flex !important;
    flex: 0 0 38px;
    min-width: 38px;
    background: rgba(255, 255, 255, .96);
    box-shadow: 0 0 8px rgba(31, 38, 70, .08);
    z-index: 2;
  }
  .tabs-module__headers ::v-deep .v-slide-group__prev--disabled,
  .tabs-module__headers ::v-deep .v-slide-group__next--disabled {
    opacity: .35;
  }
  .tabs-module__headers ::v-deep .v-tab {
    min-height: 42px;
    padding: 0 13px;
    font-size: .86rem;
  }
  .tabs-module__label { white-space: nowrap; }
}
@media (max-width: 600px) {
  .tabs-module { margin: 0 -2px; }
  .tabs-module__headers ::v-deep .v-slide-group__prev,
  .tabs-module__headers ::v-deep .v-slide-group__next {
    flex-basis: 34px;
    min-width: 34px;
  }
}
</style>
